import React from 'react';
import { usePortfolio } from './../Context/PortfolioContext'; // Adjust the path as needed

const ESGResultsVisualization = ({ data }) => {
    const { portfolioData } = usePortfolio();
    const { optimizationMethod, optimizationResults, selectedAssets } = portfolioData;
    // Assuming data.optimizedWeights is an array of weights
    if (!data || !data.optimizedWeights) {
        return <p>No ESG optimization results to display.</p>;
    }

    return (
        <div>
            <h3>ESG Optimization Results</h3>
            <ul>
                {data.optimizedWeights.map((weight, index) => (
                    <li key={index}>Asset {index + 1}: Weight = {weight.toFixed(4)}</li>
                ))}
            </ul>
        </div>
    );
};

export default ESGResultsVisualization;